module.exports = __webpack_public_path__ + "static/media/import-url.4bdb4364.svg";